import * as React from 'react'

import {AdminPaymentRefund} from '@/api/models'
import DataTable from '@/common/data-table'
import useTableState from '@/common/data-table/use-table-state'
import useSupabaseQuery from '@/common/use-custom-query'

import {columns, defaultSelectedColumns, filterFields} from './constants'

const PaymentRefunds = () => {
  const tableState = useTableState({descending: true, sortBy: 'created_at'})
  const {loading, data, fetch, rows} = useSupabaseQuery<AdminPaymentRefund>({
    table: 'admin_payment_refunds',
    fields: '*',
    pageNumber: tableState.page,
    descending: tableState.descending,
    itemsPerPage: tableState.rowsPerPage,
    order: tableState.sortBy.column as keyof AdminPaymentRefund,
    filter: tableState.filter,
  })

  return (
    <DataTable<AdminPaymentRefund>
      table="admin_payment_refunds"
      columns={columns}
      data={data ?? []}
      totalCount={rows}
      tableState={tableState}
      onRefresh={fetch}
      loading={loading}
      filterFields={filterFields}
      defaultSelectedColumns={defaultSelectedColumns}
    />
  )
}

export default PaymentRefunds
